const ZERO_OPACITY_VISIBLE_RULES = new Map<string, Set<string>>([
  ["EQ_Landslide_Global_SwissRe", new Set(["Negligible"])],
  ["CS_Lightning_Global_SwissRe", new Set(["Very Low (<1)"])]
]);

const ALWAYS_HIDDEN_RULES = new Map<string, Set<string>>([
  ["CS_Tornado_Global_SwissRe", new Set(["No Observation"])]
]);

function matchesLegendRule(
  rules: Map<string, Set<string>>,
  layerId: string | undefined,
  title: string | undefined
) {
  if (!layerId || !title) {
    return false;
  }

  return rules.get(layerId)?.has(title) ?? false;
}

export function shouldDisplayLegendRule(
  layerId: string | undefined,
  title: string | undefined,
  opacity: number | undefined
) {
  if (opacity === 0) {
    return matchesLegendRule(ZERO_OPACITY_VISIBLE_RULES, layerId, title);
  }

  return !matchesLegendRule(ALWAYS_HIDDEN_RULES, layerId, title);
}

export function getLegendDisplayOpacity(
  layerId: string | undefined,
  title: string | undefined,
  opacity: number | undefined
) {
  if (
    opacity === 0 &&
    matchesLegendRule(ZERO_OPACITY_VISIBLE_RULES, layerId, title)
  ) {
    return 1;
  }

  return opacity;
}